<!-- from https://www.merchantsignage.visa.com/brand_guidelines -->
@if (!darkTheme) {
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 3384.5 2077.9"
    style="enable-background: new 0 0 3384.5 2077.9"
    xml:space="preserve"
  >
    <style type="text/css">
      .st0 {
        fill: #1434cb;
      }
    </style>
    <g id="Layer_2"></g>
    <g id="Layer_3"></g>
    <g id="Layer_1">
      <path
        class="st0"
        d="M1461.3,739.8l-251.4,599.7h-164L922.2,861c-7.5-29.5-14-40.3-36.9-52.7c-37.3-20.2-98.9-39.2-153-51l3.7-17.4
		h264c33.6,0,63.9,22.4,71.5,61.2l65.3,347l161.5-408.2L1461.3,739.8L1461.3,739.8z M2103.8,1143.8c0.7-158.3-218.9-167-217.4-237.7
		c0.5-21.5,21-44.4,65.8-50.2c22.2-2.9,83.5-5.1,152.9,26.8l27.2-127.2c-37.3-13.5-85.4-26.6-145.1-26.6
		c-153.3,0-261.3,81.5-262.2,198.2c-1,86.3,77,134.5,135.8,163.2c60.5,29.4,80.8,48.3,80.5,74.5c-0.4,40.2-48.2,58-92.9,58.7
		c-78,1.2-123.2-21.1-159.3-37.9l-28.1,131.4c36.2,16.6,103.2,31.1,172.5,31.9C1996.7,1349,2103.3,1268.4,2103.8,1143.8
		 M2508.8,1339.6h143.5L2527,739.8h-132.4c-29.8,0-54.9,17.3-66,44l-232.8,555.7h162.9l32.3-89.6h199.1L2508.8,1339.6z
		 M2335.7,1127.1l81.7-225.2l47,225.2H2335.7z M1682.9,739.8l-128.3,599.7h-155.1l128.3-599.7L1682.9,739.8L1682.9,739.8z"
      />
    </g>
  </svg>
}

@if (darkTheme) {
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 3384.5 2077.9"
    style="enable-background: new 0 0 3384.5 2077.9"
    xml:space="preserve"
  >
    <style type="text/css">
      .st0 {
        fill: #ffffff;
      }
    </style>
    <path
      class="st0"
      d="M1461.3,739.8l-251.4,599.7h-164L922.2,861c-7.5-29.5-14-40.3-36.9-52.7c-37.3-20.2-98.9-39.2-153-51l3.7-17.4
	h264c33.6,0,63.9,22.4,71.5,61.2l65.3,347l161.5-408.2L1461.3,739.8L1461.3,739.8z M2103.8,1143.8c0.7-158.3-218.9-167-217.4-237.7
	c0.5-21.5,21-44.4,65.8-50.2c22.2-2.9,83.5-5.1,152.9,26.8l27.2-127.2c-37.3-13.5-85.4-26.6-145.1-26.6
	c-153.3,0-261.3,81.5-262.2,198.2c-1,86.3,77,134.5,135.8,163.2c60.5,29.4,80.8,48.3,80.5,74.5c-0.4,40.2-48.2,58-92.9,58.7
	c-78,1.2-123.2-21.1-159.3-37.9l-28.1,131.4c36.2,16.6,103.2,31.1,172.5,31.9C1996.7,1349,2103.3,1268.4,2103.8,1143.8
	 M2508.8,1339.6h143.5L2527,739.8h-132.4c-29.8,0-54.9,17.3-66,44l-232.8,555.7h162.9l32.3-89.6h199.1L2508.8,1339.6z
	 M2335.7,1127.1l81.7-225.2l47,225.2H2335.7z M1682.9,739.8l-128.3,599.7h-155.1l128.3-599.7L1682.9,739.8L1682.9,739.8z"
    />
  </svg>
}
